import { h } from "preact";
import { Box, makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  sectionContainer: {
    overflow: "hidden",
  },
  content: {
    height: "100%",
    "& > div:nth-of-type(1)": {
      height: "inherit",
    },
  },
}));

export function Section({ selector, children, className }) {
  const classes = useStyles();
  return (
    <Box className={`${selector} ${classes.sectionContainer} ${className}`}>
      <Box className={classes.content} id="content">
        {children}
      </Box>
    </Box>
  );
}

Section.defaultProps = {
  selector: "fullpage",
  children: [],
};
